import { queryOptions } from "@tanstack/react-query";
import { POLL_MS, TEAM_SCREEN_POLL_MS, apiGet, withQuery } from "@amber/ui";
import {
  funnelResponseSchema,
  homeResponseSchema,
  type FunnelBreakdown,
  type HomeFrame,
} from "@amber/application/contracts";

export const homeKeys = {
  frame: (frame: HomeFrame) => ["home", frame] as const,
  funnel: (frame: HomeFrame, by: FunnelBreakdown) => ["home", "funnel", frame, by] as const,
} as const;

export const homeQuery = (frame: HomeFrame, team: boolean) =>
  queryOptions({
    queryKey: homeKeys.frame(frame),
    queryFn: ({ signal }) => apiGet(withQuery("/api/home", { frame }), homeResponseSchema, signal),
    refetchInterval: team ? TEAM_SCREEN_POLL_MS : POLL_MS,
    placeholderData: (previous) => previous,
  });

export const funnelQuery = (frame: HomeFrame, by: FunnelBreakdown) =>
  queryOptions({
    queryKey: homeKeys.funnel(frame, by),
    queryFn: ({ signal }) => apiGet(withQuery("/api/home/funnel", { frame, by }), funnelResponseSchema, signal),
    refetchInterval: POLL_MS,
    placeholderData: (previous) => previous,
  });
